import React, { Component } from 'react'
import Header from '../Header'
import './XXIw.css'

class XXIw extends Component {
  
    render () {
        return (
            <div>
                <Header />
                <div className="bodyXXIw">
                    <p className="textXXIw">A venir...</p>
                </div>
            </div>
        )
    }
}

export default XXIw